import { render, staticRenderFns } from "./PointLayout.vue?vue&type=template&id=0caee46a&scoped=true&"
import script from "./PointLayout.vue?vue&type=script&lang=js&"
export * from "./PointLayout.vue?vue&type=script&lang=js&"
import style0 from "./PointLayout.vue?vue&type=style&index=0&id=0caee46a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caee46a",
  null
  
)

export default component.exports